module.exports = __webpack_public_path__ + "img/irt.53c6b034.svg";